<svg
  (mouseenter)="mouseEnter()"
  (mouseleave)="mouseLeave()"
  [attr.height]="height"
  [attr.width]="width"
  [class.cursor-pointer]="isButton"
  fill="none"
  viewBox="0 0 18 14"
>
  <path
    [attr.fill]="color"
    d="M16 7L16.5303 6.46967L17.0607 7L16.5303 7.53033L16 7ZM0 6.25H16V7.75H0V6.25ZM9.46967 12.4697L15.4697 6.46967L16.5303 7.53033L10.5303 13.5303L9.46967 12.4697ZM15.4697 7.53033L9.46967 1.53033L10.5303 0.46967L16.5303 6.46967L15.4697 7.53033Z"
  />
</svg>
